import type { AccessChange, AccessLevel, AccessRow } from "../../../api/access";

/** Missing key means untouched; null is an explicit request to restore inheritance. */
export type AccessDraft = Record<string, AccessLevel | null>;

export function configuredValue(row: AccessRow, draft: AccessDraft): AccessLevel | null {
  return Object.prototype.hasOwnProperty.call(draft, row.section) ? draft[row.section] : row.configuredLevel;
}

export function effectiveValue(row: AccessRow, draft: AccessDraft): AccessLevel {
  if (!Object.prototype.hasOwnProperty.call(draft, row.section)) return row.effectiveLevel;
  return draft[row.section] ?? row.inheritedLevel;
}

export function changeDraft(draft: AccessDraft, row: AccessRow, value: AccessLevel | null): AccessDraft {
  const next = { ...draft };
  if (row.configuredLevel === value) delete next[row.section];
  else next[row.section] = value;
  return next;
}

export function draftChanges(draft: AccessDraft): AccessChange[] {
  return Object.entries(draft).map(([section, level]) => level === null
    ? { section, operation: "RESET_TO_INHERITED" }
    : { section, operation: "SET_LEVEL", level });
}
